const defaultEnvironment = {
  APPLICATIONINSIGHTS_CONNECTION_STRING: 'InstrumentationKey=123',
  AZURE_ENV: 'prod',
  BOUWDOSSIER_API_ROOT: 'https://bouwdossiers.amsterdam.nl/',
  CATALOGUS_API_ROOT: 'https://dmpfunc002.amsterdam.nl/marketplace',
  DATA_SELECTION_API_ROOT: 'https://ont.api.amsterdam.nl/dataselectie/',
  DEPLOY_ENV: 'production',
  DSO_API_KEY:
    'eyJhbGciOiJFZERTQSIsInR5cCI6IkpXVCJ9.eyJzdWIiOjYwMzY0MDQ4OTA0NzYyMDc3NjcsImV4cCI6MTczMTA2NDM3M30.1w8a7hs396OrP25ChSR2gRCIiDKJVwd7fXPgPVFy8IN8KXfFlUUR25wzLjPekFVjKTnrLlxLcP2kkDM895ZeAw',
  DSO_API_ROOT: 'https://api.data.amsterdam.nl/',
  DATAPORTAAL_API_ROOT: 'https://api.dataportaal.amsterdam.nl/',
  KEYCLOAK_CLIENT: 'data-verkenner',
  KEYCLOAK_REALM: 'datapunt-ad',
  KEYCLOAK_URL: 'https://iam.amsterdam.nl/auth',
  PIWIK_KEY: 'f558164e-e388-49e0-864e-5f172552789c',
  PIWIK_URL: 'https://dap.amsterdam.nl',
  ROOT: 'https://data.amsterdam.nl/',
  SEARCH_URL: 'https://search.amsterdam.nl/',
}
type Environment = typeof defaultEnvironment
const environment: Environment = { ...defaultEnvironment, ...getEnvironmentVariables() }

/**
 * Gets the environment variables provided at startup to the Docker container.
 *
 * The values are placed in a script tag in the HTML which contains a JSON representation of the environment.
 */
function getEnvironmentVariables(): { [key: string]: string } {
  const element = document.getElementById('environment')
  const config = element?.textContent ? JSON.parse(element.textContent) : {}

  return config
}

export default environment
